import React from 'react';
import { FadeIn } from './FadeIn';
import { SafeImage } from './SafeImage';
import { WhatsAppButton } from './WhatsAppButton';
export function AboutZev() {
  return <section className="py-20 md:py-32 px-6 md:px-12 bg-creamDeep relative" data-id="element-11" data-mp="35v00q2wszb5l">
      <div className="max-w-6xl mx-auto" data-id="element-12" data-mp="3kp4x8puj6vjb">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center" data-id="element-13" data-mp="3fr34teb7tjv6">
          {/* Image side */}
          <div className="lg:col-span-6 relative" data-id="element-14" data-mp="2s0fvqppkco71">
            <FadeIn data-id="element-15" data-mp="2rywbyp4p7v0i">
              <div className="relative aspect-[3/4] w-full max-w-md mx-auto lg:max-w-none overflow-hidden rounded-sm" data-id="element-16" data-mp="2n2e9jvwuc8rc">
                <SafeImage src="https://a0.muscache.com/im/pictures/user/User-23169165/original/34c0edf4-86f2-420d-9ab5-075f889acc9f.jpeg?im_w=720" fallbackSrc="https://cdn.magicpatterns.com/uploads/kEWdox2XZmrj2PeAtGRtko/549193096_122201298908570946_2685253799441819983_n.jpg" alt="Zev Gelber, founder of Pines Retreat" className="w-full h-full object-cover" data-id="element-17" data-mp="31raehk3lp5nq" />
              </div>
            </FadeIn>
            {/* Small overlap thumbnail */}
            <FadeIn delay={0.3} className="hidden lg:block absolute -bottom-8 -right-4 w-48 h-48 z-10" data-id="element-18" data-mp="2e51ca9xbkyqx">
              <div className="w-full h-full overflow-hidden rounded-sm border-4 border-creamDeep shadow-xl" data-id="element-19" data-mp="2nw4exg5wdlsb">
                <img src="https://cdn.magicpatterns.com/uploads/7Qys8tKbwECbxzbYaa92kV/472354039_122134502762570946_1769931133132476279_n.jpg" alt="Zev with a friend at the retreat" className="w-full h-full object-cover" data-id="element-20" data-mp="1r6mz48d7ajcw" />
              </div>
            </FadeIn>
          </div>

          {/* Text side */}
          <div className="lg:col-span-6 lg:pl-8" data-id="element-21" data-mp="3blysy11ydge5">
            <FadeIn data-id="element-22" data-mp="3bl6w6mwmdcma">
              <p className="text-clay/70 uppercase tracking-[0.2em] text-xs font-medium mb-4" data-id="element-23" data-mp="3blqazuqz3kw3">
                Who you'll meet
              </p>
            </FadeIn>
            <FadeIn delay={0.1} data-id="element-24" data-mp="2qvw9zla2r36v">
              <h2 className="font-serif text-4xl md:text-5xl text-pine mb-8" data-id="element-25" data-mp="2qv31aerk23m3">
                Zev Gelber
              </h2>
            </FadeIn>
            <FadeIn delay={0.2} data-id="element-26" data-mp="30vn2jhf2r84b">
              <p className="text-lg md:text-xl text-clay font-light leading-relaxed mb-6" data-id="element-27" data-mp="30tsevvcf51wj">
                Zev brings together facilitation, music, cold exposure, sauna,
                and community-building to create spaces where people can slow
                down, reconnect, and reset.
              </p>
            </FadeIn>
            <FadeIn delay={0.25} data-id="element-28" data-mp="235idnikgii6h">
              <p className="text-base text-clay/90 font-light leading-relaxed mb-10" data-id="element-29" data-mp="2hwrd0je5vhwt">
                He's a social worker, ice bath facilitator, musician, and
                long-time community builder. The land is an extension of how he
                shows up: warm, honest, and ready to hold whatever you bring.
              </p>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-30" data-mp="1ker70orut5vs">
              <div className="flex flex-wrap gap-2 mb-10" data-id="element-31" data-mp="3w4guhsfto224">
                {['Ice Bath Facilitator', 'Social Worker', 'Musician', 'Retreat Facilitator'].map(tag => <span key={tag} className="px-4 py-1.5 bg-cream border border-pine/15 text-pine text-sm rounded-full" data-id="element-32" data-mp="3m3y6clh85zee">
                    {tag}
                  </span>)}
              </div>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-33" data-mp="nnm4hdk4ic5g">
              <WhatsAppButton variant="link" label="Message Zev on WhatsApp" data-id="element-34" data-mp="9omg870ivz9t" />
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}